import { RichTextInput } from "@circle-react-uikit/RichTextInput";
import { useFormContext, useWatch } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import type { TrixFormValues } from "@/react/components/CommentsCompass/types";
import { useSubmitViaKeyboard } from "@/react/hooks/utils/useSubmitViaKeyboard";

import { EditModalShell } from "./EditModalShell";

import styles from "@/react/components/CommentsCompass/trix.module.css";

export const FORM_ID = "comment-edit-trix-form";

interface TrixEditBodyProps {
  spaceId: number;
}

export const TrixEditBody = ({ spaceId }: TrixEditBodyProps) => {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<TrixFormValues>();
  const body = useWatch({ control, name: "body" });
  const isBodyEmpty = !body;

  useSubmitViaKeyboard({ enabled: !isBodyEmpty && !isSubmitting });

  return (
    <EditModalShell formId={FORM_ID} disabled={isBodyEmpty}>
      <div className={styles.editorWrapper}>
        <RichTextInput
          id="comment-edit-body"
          name="body"
          placeholder={t("comments.form.fields.body_placeholder")}
          className="h-full"
          editorContainerClassName="flex flex-col h-full"
          textboxClassName="overflow-auto rounded-md py-4 sm:max-h-[40vh]"
          space_id={spaceId}
        />
      </div>
    </EditModalShell>
  );
};
